export default __webpack_public_path__ + "static/media/cosmoplan_logo.77a66f5b.png";